/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { hasErrorBoundary } from '@xmanscript/has-error-boundary';
import FileCard, { FileCardSkeleton } from '../FileCard';
import { FileData } from '..';

interface PreviewFilesProps {
  files: FileData[];
  handleFileDelete?: (file: FileData) => void;
  previewFiles?: boolean;
  canEditFile?: boolean;
  isLoading?: boolean;
  customDeleteFn?: (file: FileData) => void;
}

const PreviewFiles: React.FC<PreviewFilesProps> = ({ files, handleFileDelete, isLoading, customDeleteFn }) => {
  const handleOverallFileDelete = (file: FileData) => {
    if (handleFileDelete) handleFileDelete(file);

    if (customDeleteFn) customDeleteFn(file);
  };

  if (isLoading)
    return (
      <div className="flex flex-col gap-1">
        {isLoading &&
          [...Array(2)].map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <FileCardSkeleton key={`skeleton-${index}`} />
          ))}
      </div>
    );

  if (files.length > 0)
    return (
      <div className="flex w-full flex-col gap-1">
        {files.length > 0 &&
          files?.map((file, index) => (
            <FileCard
              // eslint-disable-next-line no-underscore-dangle
              key={file._id || `file-${index}`}
              // canEditFile={canEditFile}
              file={file}
              // @ts-ignore
              handleDeleteFile={handleOverallFileDelete} // Corrected function assignment
              index={index}
              // previewFile={previewFiles}
            />
          ))}
      </div>
    );

  return <p>No Files Selected</p>;
};

export default hasErrorBoundary(PreviewFiles);
